import { cashZPdfApi } from "../../api";

const CashZPdfService = {

    /**
     * 📄 Descargar PDF
     * del Corte Z (cierre histórico)
     *
     * GET /api/pdf/cash/closures/{closureId}
     */
    download: async (closureId: number): Promise<{
        blob: Blob;
        fileName: string | null;
    }> => {

        const response =
            await cashZPdfApi.fetchBlob(`/${closureId}`);

        return {

            blob: response.data,

            fileName:
                response.fileName ||
                `corte_z_${closureId}.pdf`,
        };
    },
};

export default CashZPdfService;
